import { useContext } from 'react';
import { useMentorsContext } from '../../contexts/mentors-context';
import { UserContext } from '../../contexts/user-context';
import ConfirmModal from '../common/confirm-modal';

function MentorProfileUpdateModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    isSendingProfileUpdate,
    profileUpdateTargetMentorId,
    setProfileUpdateTargetMentorId,
    handleSendMentorUpdateProfiles,
  } = useMentorsContext();

  return hasAccessToAction('mentor.details.update') ? (
    <ConfirmModal
      isOpen={!!profileUpdateTargetMentorId}
      onClose={() => setProfileUpdateTargetMentorId(null)}
      title='Send Single Profile Update Request'
      loading={isSendingProfileUpdate}
      body='Your are about to send a temporary link to allow participants to update their profile. The link can work only 1 time, and is available for 48 hours only.'
      successProps={{
        btnLabel: 'Ok',
        onSuccess: handleSendMentorUpdateProfiles,
      }}
      cancelProps={{
        btnLabel: 'Cancel',
      }}
    />
  ) : null;
}

export default MentorProfileUpdateModal;
